<div class="f-row filled-action-row">
  <h6 class="title-subText m-bottom-8x">{{content?.['b2b.register.personalinformation']}}</h6>
</div>

<form class="form-info-section" [formGroup]="travelerSignupForm">
  <div class="f-row">
    <div class="f-col">
      <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
        [searchFn]="_CommonService.customCountrySearchFn" formControlName="Nationality" bindValue="isoCode"
        [placeholder]="content?.['b2b.register.nationality']" (contextmenu)="_CommonService.disableRightClick($event)"
        (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.group }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-option-label">
            <ng-container *ngIf="!!item?.newFlag?.src">
              <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                [height]="item.height" [width]="item.width" />
            </ng-container>
            {{ item?.countryName }}
          </span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label"> {{ item.nationality }} </span>
        </ng-template>
        <ng-template ng-notfound-tmp>
          <div class="no-items-found">
            <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
            <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
          </div>
        </ng-template>
      </ng-select>

      <mat-error class="px-4" *ngIf="
          travelerSignupForm.get('Nationality')?.hasError('required') &&
          travelerSignupForm.get('Nationality')?.touched
        ">
        {{content?.dictionary?.['b2b.managetraveler.selectnationality']}}</mat-error>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
        [searchFn]="_CommonService.customCountrySearchFn" formControlName="residence" bindValue="isoCode"
        [placeholder]="content?.['b2b.register.placeofresidence'] || 'Place of Residence'" (contextmenu)="_CommonService.disableRightClick($event)"
        (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.group }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-option-label">
            <ng-container *ngIf="!!item?.newFlag?.src">
              <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                [height]="item.height" [width]="item.width" />
            </ng-container>
            {{ item?.countryName }}
          </span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label"> {{ item.countryName }} </span>
        </ng-template>
        <ng-template ng-notfound-tmp>
          <div class="no-items-found">
            <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
            <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
          </div>
        </ng-template>
      </ng-select>

      <mat-error class="px-4" *ngIf="
          travelerSignupForm.get('residence')?.hasError('required') &&
          travelerSignupForm.get('residence')?.touched
        ">
        {{content?.dictionary?.['b2b.register.selectpor']}}</mat-error>
    </div>
  </div>

  <div class="f-row" *ngIf=" travelerSignupForm.get('Nationality')?.value && travelerSignupForm.get('residence')?.value">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{this.CommonObj.docName || 'National ID/IQAMA/Passport'}}</mat-label>

        <!-- (blur)="verifyELM('nn')" -->
        <input matInput formControlName="identityNumber" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters1($event)" (blur)="verifyELM('nn')" />
        <!--   for duplicate cmp name check-->
        <mat-error
          *ngIf="travelerSignupForm.get('identityNumber')?.hasError('required') && travelerSignupForm.get('identityNumber')?.touched">
          Please enter your {{ CommonObj.docName || 'ID number' }}.
        </mat-error>

        <mat-error
          *ngIf="travelerSignupForm.get('identityNumber')?.hasError('pattern') && travelerSignupForm.get('identityNumber')?.touched">
          <ng-container *ngIf="CommonObj.docType === 'passport'">
            {{ content?.dictionary?.['b2b.booking.passportnumberlengtherror'] || 'Passport number should be between 6-12 alphanumeric characters' }}
          </ng-container>

          <ng-container *ngIf="CommonObj.docType == 'nationalID'">
            {{ content?.['phrases.b2b.managetraveler.nationalidexactlimit'] }}
          </ng-container>

          <ng-container *ngIf="CommonObj.docType == 'iqama'">
            {{ content?.['phrases.b2b.managetraveler.iqamaexactlimit'] }}
          </ng-container>

        </mat-error>

        <mat-error *ngIf="travelerSignupForm.get('identityNumber')?.hasError('elmError')"> ELM-({{CommonObj.docName}}
          is Invalid.) </mat-error>

      </mat-form-field>

    </div>
  </div>

  <div class="f-col hideCalendar position-relative">
    <mat-form-field (click)="showComponent('isDOBCalendarVisible','dateOfBirth'); $event.stopPropagation()"
      (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
      (keypress)="_CommonService.blockInvalidCharacters1($event)">
      <mat-label>{{content?.['b2b.register.dob']}}</mat-label>
      <mat-icon fontSet="material-symbols-outlined" matSuffix> calendar_today </mat-icon>

      <!-- (blur)="verifyELM('nn')" -->
      <input matInput #dobInput formControlName="dateOfBirth" readonly data-dd-privacy="mask"
        (blur)="verifyELM('nn')" />

      <mat-error
        *ngIf="travelerSignupForm.get('dateOfBirth')?.hasError('required') && travelerSignupForm.get('dateOfBirth')?.touched">
        {{content?.dictionary?.['b2b.passenger.errordateofbirth']}}</mat-error>
    </mat-form-field>
    <app-date-of-birth-calendar *ngIf="isChildVisible['isDOBCalendarVisible']" (dateSelected)="onDateSelected($event)"
      (confirm)="onConfirm('isDOBCalendarVisible')"></app-date-of-birth-calendar>
  </div>

  <div class="f-col position-relative admin-info-calendar" *ngIf=" travelerSignupForm.get('Nationality')?.value && travelerSignupForm.get('residence')?.value">
    <mat-form-field appearance="fill" (click)="
        showComponent('isExpiaryCalendarVisible', 'docExpiary');
        $event.stopPropagation()
      " (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
      (keypress)="_CommonService.blockInvalidCharacters1($event)">
      <mat-label>{{ this.CommonObj.docName }} Expiry Date</mat-label>
      <input matInput [placeholder]="content?.['b2b.register.selectexpirydate'] || 'Select your expiry date'" formControlName="docExpiary" data-dd-privacy="mask" [value]="
          selectedExpiryDate ? (selectedExpiryDate | date : 'dd/MM/y') : ''
        " readonly />
      <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
      <mat-error *ngIf="
          travelerSignupForm.get('docExpiary')?.hasError('required') &&
          travelerSignupForm.get('docExpiary')?.touched
        ">
        {{ this.CommonObj.docName }} expiry date is required.
      </mat-error>
    </mat-form-field>
    <app-expiry-date *ngIf="isChildVisible['isExpiaryCalendarVisible']" [passengerTravelerCode]="'ADT'"
      (dateSelected)="onDateSelected2($event, 'isExpiaryCalendarVisible')"
      (confirm)="onConfirm('isExpiaryCalendarVisible')" [filledDate]="
        selectedExpiryDate ? (selectedExpiryDate | date : 'dd/MM/y') : ''
      " [maxYearLimit]="docExpiryMaxYears" [useCurrentDateAsMin]="true">
    </app-expiry-date>
  </div>



  <div class="f-row two--ColLayout passenger-title-input">
    <div class="f-col control-wrapper">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.title']}}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"> stat_minus_1 </mat-icon>
        <mat-select disableRipple formControlName="title" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">

          <mat-option [value]="title.Phrase" *ngFor="let title of titles">{{title.Phrase}}</mat-option>
        </mat-select>
        <mat-error *ngIf="
            travelerSignupForm.get('title')?.hasError('required') &&
            travelerSignupForm.get('title')?.touched
          ">
          {{content?.dictionary?.['b2b.managetraveler.selectatitle']}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="f-col control-wrapper">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.firstname']}}</mat-label>
        <input matInput formControlName="firstname" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters1($event)" />
        <mat-error *ngIf="
            travelerSignupForm.get('firstname')?.hasError('required') &&
            travelerSignupForm.get('firstname')?.touched
          ">
          {{content?.dictionary?.['b2b.register.enterfirstname']}}
        </mat-error>
        <mat-error *ngIf="travelerSignupForm.get('firstname')?.hasError('maxlength')">
          {{content?.dictionary?.['b2b.register.cannotexceedfirstname']}}
        </mat-error>
        <!-- <mat-error> Please enter a valid input.</mat-error>  -->
        <mat-error *ngIf="travelerSignupForm.get('firstname')?.hasError('minlength')">
          {{content?.dictionary?.['b2b.register.firstname2char']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <!-- <div class="f-col">
            <mat-form-field>
                <mat-label>Middle Name (Optional)</mat-label>
                <input matInput />
                <mat-error> Please enter middle
                    name. </mat-error>
                <mat-error> First name cannot
                    exceed 50 characters. </mat-error>
                <mat-error>
                    Please enter a valid input. </mat-error>
                <mat-error> First Name must be
                    at least 2 characters. </mat-error>
            </mat-form-field>
        </div> -->
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.lastname']}}</mat-label>
        <!-- <input matInput  /> -->
        <input matInput formControlName="lastname" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters1($event)" />
        <mat-error *ngIf="
            travelerSignupForm.get('lastname')?.hasError('required') &&
            travelerSignupForm.get('lastname')?.touched
          ">
          {{content?.dictionary?.['b2b.register.enterlastname']}}
        </mat-error>
        <mat-error *ngIf="
            travelerSignupForm.get('lastname')?.hasError('maxlength') &&
            travelerSignupForm.get('lastname')?.touched
          ">
          {{content?.dictionary?.['b2b.managetraveler.lastname50char']}}
        </mat-error>
        <!-- <mat-error> Please enter a valid input. </mat-error> -->
        <mat-error *ngIf="
            travelerSignupForm.get('lastname')?.hasError('minlength') &&
            travelerSignupForm.get('lastname')?.touched
          ">
          {{content?.dictionary?.['b2b.managetraveler.lastname2char']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <div class="f-row validation-col radio-group-container">
        <label class="mat-label" for="Gender">{{content?.['b2b.register.gender']}}</label>
        <mat-radio-group id="gender" aria-label="Select a gender" formControlName="gender">
          <mat-radio-button value="Male">{{content?.['b2b.register.male']}}</mat-radio-button>
          <mat-radio-button value="Female">{{content?.['b2b.register.female']}}</mat-radio-button>
        </mat-radio-group>
        <!-- <mat-error *ngIf="businessOwnerForm.get('gender')?.hasError('required') && businessOwnerForm.get('gender')?.touched"> Please select a gender. </mat-error> -->
      </div>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.employeecode ']}}</mat-label>
        <input matInput formControlName="empCode" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters1($event)" />
        <mat-error *ngIf="
            travelerSignupForm.get('empCode')?.hasError('required') &&
            travelerSignupForm.get('empCode')?.touched
          ">
          {{content?.dictionary?.['b2b.register.employeecodereq']}}
        </mat-error>
        <mat-error *ngIf="
            travelerSignupForm.get('empCode')?.hasError('minlength') &&
            travelerSignupForm.get('empCode')?.touched
          ">
          {{content?.dictionary?.['b2b.register.employeecode4char']}}
        </mat-error>
        <mat-error *ngIf="
            travelerSignupForm.get('empCode')?.hasError('maxlength') &&
            travelerSignupForm.get('empCode')?.touched
          ">
          {{content?.dictionary?.['b2b.register.cannotexceedempcode']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.emailaddress']}}</mat-label>
        <input matInput formControlName="email" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.blockInvalidCharacters($event)" />
        <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
        <mat-error *ngIf="travelerSignupForm.get('email')?.hasError('existEmail')">
          {{content?.dictionary?.['b2b.register.emailexists']}}
        </mat-error>
        <mat-error *ngIf="
            travelerSignupForm.get('email')?.hasError('required') &&
            travelerSignupForm.get('email')?.touched
          ">
          {{content?.dictionary?.['b2b.register.emailaddressreq']}}
        </mat-error>
        <mat-error *ngIf="
            travelerSignupForm.get('email')?.hasError('maxlength') &&
            travelerSignupForm.get('email')?.touched
          ">
          {{content?.dictionary?.['b2b.register.cannotexceedemail']}}
        </mat-error>
        <!-- <mat-error> This email already exists. </mat-error> -->
        <mat-error *ngIf="
            travelerSignupForm.get('email')?.hasError('email') &&
            travelerSignupForm.get('email')?.touched
          ">
          {{content?.dictionary?.['b2b.register.entervalidinput']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row two--ColLayout">
    <div class="f-col">
      <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
        [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryCode" bindValue="code"
        [placeholder]="content?.['b2b.register.countrycode']" (contextmenu)="_CommonService.disableRightClick($event)"
        (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters($event)">
        <ng-template ng-optgroup-tmp let-item="item">
          {{ item.group }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="ng-option-label">
            <ng-container *ngIf="!!item?.newFlag?.src">
              <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                [height]="item.height" [width]="item.width" />
            </ng-container>
            {{ item.code }} ({{ item?.countryName }})
          </span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span class="ng-value-label"> {{ item.code }} </span>
        </ng-template>
        <ng-template ng-notfound-tmp>
          <div class="no-items-found">
            <img src="assets/images/not-found.png" [alt]="content?.['b2b.managetraveler.noitemsfound'] || 'No items found'" class="no-items-image" />
            <p> {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
          </div>
        </ng-template>
      </ng-select>

      <mat-error class="px-4" *ngIf="
          travelerSignupForm.get('countryCode')?.hasError('required') &&
          travelerSignupForm.get('countryCode')?.touched
        ">
        {{content?.dictionary?.['b2b.register.selectcountrycode']}}</mat-error>
    </div>
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.mobileno']}}
        </mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
        <input type="text" matInput formControlName="mobileNumber" data-dd-privacy="mask"
          (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (keypress)="_CommonService.allowNumberOnly($event)" />
        <mat-error *ngIf="
            travelerSignupForm.get('mobileNumber')?.hasError('required') &&
            travelerSignupForm.get('mobileNumber')?.touched
          ">{{content?.dictionary?.['b2b.register.mobilereq']}}
        </mat-error>
        <mat-error *ngIf=" travelerSignupForm.get('mobileNumber')?.hasError('minlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>
        <mat-error *ngIf=" travelerSignupForm.get('mobileNumber')?.hasError('maxlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>

        <!-- <mat-error *ngIf=" travelerSignupForm.get('mobileNumber')?.hasError('pattern') ">Mobile number must be 10 digit. </mat-error> -->
      </mat-form-field>
    </div>
  </div>

  <div class="f-row two--ColLayout">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.officelocation']}}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"> stat_minus_1 </mat-icon>
        <mat-select disableRipple formControlName="branch" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">
          <mat-option [value]="item.branchId" *ngFor="let item of branchList">{{
            item.branchName
            }}</mat-option>
        </mat-select>
        <mat-error> {{onBoardContent?.['b2b.register.selectbranch']}} </mat-error>
      </mat-form-field>
    </div>

    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.department']}}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"> stat_minus_1 </mat-icon>
        <mat-select disableRipple formControlName="department" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">
          <mat-option [value]="item.deptId" *ngFor="let item of departmentsList">{{
            item.deptName
            }}</mat-option>
        </mat-select>
        <mat-error> {{onBoardContent?.['b2b.register.selectbranch']}} </mat-error>
      </mat-form-field>
    </div>

  </div>

  <div class="f-row two--ColLayout">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.designation']}}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select"> stat_minus_1 </mat-icon>
        <mat-select disableRipple formControlName="designation" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (keypress)="_CommonService.blockInvalidCharacters1($event)">
          <mat-option [value]="item.desigId" *ngFor="let item of designationsList">{{
            item.desigName
            }}</mat-option>
        </mat-select>
        <mat-error> {{onBoardContent?.['b2b.register.selectbranch']}} </mat-error>
      </mat-form-field>
    </div>

  </div>

  <div class="f-row">
    <div class="f-col">
      <div class="f-row validation-col radio-group-container">
        <label class="mat-label" for="UeserType">{{onBoardContent?.['b2b.managetraveler.usertype']}}</label>
        <mat-radio-group id="UeserType" aria-label="Select a gender" formControlName="userType">
          <mat-radio-button value="0">{{onBoardContent?.['b2b.managetraveler.administrator']}}</mat-radio-button>
          <mat-radio-button value="1">{{onBoardContent?.['b2b.managetraveler.travelarranger']}}</mat-radio-button>
          <mat-radio-button value="2">{{onBoardContent?.['b2b.managetraveler.employee']}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

  <div class="f-row" *ngIf="!isFederatedAccount">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{onBoardContent?.['b2b.managetraveler.efpassword']}}</mat-label>
        <input matInput [placeholder]="onBoardContent?.['b2b.managetraveler.efpassword']" type="password"
          formControlName="password" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" [type]="hideNewPassword ? 'password' : 'text'"
          autocomplete="new-password" />

        <button mat-icon-button matSuffix (click)="togglePasswordVisibility($event)"
          [aria-label]="content?.['b2b.managetraveler.togglepassvisibility'] || 'Toggle password visibility'" type="button" tabindex="-1">
          <mat-icon fontSet="material-symbols-outlined">{{
            hideNewPassword ? "visibility_off" : "visibility"
            }}</mat-icon>
        </button>


        <mat-error
          *ngIf=" travelerSignupForm.get('password')?.hasError('required') && travelerSignupForm.get('password')?.touched ">
          {{content?.dictionary?.['b2b.register.passwordreq']}} </mat-error>


        <mat-error
          *ngIf=" travelerSignupForm.get('password')?.hasError('maxlength') && travelerSignupForm.get('password')?.touched ">
          {{content?.dictionary?.['b2b.register.cannotexceedpassword']}} </mat-error>

        <!-- <mat-error
          *ngIf=" travelerSignupForm.get('password')?.hasError('minlength') && travelerSignupForm.get('password')?.touched ">
          Password must be at least 8 characters. </mat-error> -->

        <mat-error *ngIf="travelerSignupForm.get('password')?.hasError('pattern') "
          [innerHTML]="onBoardContent?.['b2b.managetraveler.passwordrules']">
        </mat-error>

      </mat-form-field>
    </div>
  </div>

  <div class="f-row" *ngIf="!isFederatedAccount">
    <div class="f-col">
      <mat-form-field appearance="fill">
        <mat-label>{{onBoardContent?.['b2b.managetraveler.efconfirmpassword']}}</mat-label>
        <input matInput [placeholder]="onBoardContent?.['b2b.managetraveler.efpassword']" type="password"
          formControlName="confirmPassword" (contextmenu)="_CommonService.disableRightClick($event)"
          (paste)="_CommonService.onPasteBlocked($event)" [type]="hideConfirmPassword ? 'password' : 'text'" />

        <button mat-icon-button matSuffix (click)="togglePasswordVisibility1($event)"
          [aria-label]="content?.['b2b.managetraveler.togglepassvisibility'] || 'Toggle password visibility'" type="button" tabindex="-1">
          <mat-icon fontSet="material-symbols-outlined">{{
            hideConfirmPassword ? "visibility_off" : "visibility"
            }}</mat-icon>
        </button>


        <mat-error *ngIf="travelerSignupForm.get('confirmPassword')?.hasError('passwordMismatch')"> {{content?.dictionary?.['b2b.global.passwordnotmatch'] || 'Passwords do not match. Please try again.'}} </mat-error>
        <mat-error
          *ngIf=" travelerSignupForm.get('confirmPassword')?.hasError('required') && travelerSignupForm.get('confirmPassword')?.touched ">
          {{content?.dictionary?.['b2b.register.confirmpasswordreq']}} </mat-error>
        <!-- <mat-error> Password does not match. </mat-error> -->
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col registerForm-title-section">
      <h2 class="title-subText title-alfursan">
        {{onBoardContent?.['b2b.managetraveler.efalfursanloyaltypro']}}
        <span>· {{onBoardContent?.['b2b.managetraveler.optional']}}</span>
      </h2>
      <p class="link-section m-top-8x">
        {{onBoardContent?.['b2b.managetraveler.efaddyouralfursan']}}
      </p>
    </div>
  </div>
  <div class="f-row">
    <mat-slide-toggle (change)="onToggleChange($event)"
      formControlName="alfursanOptIn">{{onBoardContent?.['b2b.managetraveler.effillinfonow']}}</mat-slide-toggle>
  </div>

  <div class="f-col" *ngIf="alfursantoggle">
    <mat-form-field>
      <mat-label>{{onBoardContent?.['b2b.managetraveler.efalfursanid']?.split('/')[0]}}</mat-label>
      <input matInput formControlName="alfursanID" data-dd-privacy="mask"
        (contextmenu)="_CommonService.disableRightClick($event)" (paste)="_CommonService.onPasteBlocked($event)"
        (keypress)="_CommonService.blockInvalidCharacters1($event)" />

      <mat-error *ngIf="travelerSignupForm.get('alfursanID')?.hasError('wrong')">
        {{content?.dictionary?.['b2b.booking.changealfursanidortoggle'] || 'Change Alfursan ID or turn off the toggle'}}
      </mat-error>

      <mat-error
        *ngIf="travelerSignupForm.get('alfursanID')?.hasError('required') && travelerSignupForm.get('alfursanID')?.touched">{{onBoardContent?.['b2b.managetraveler.efalfursanid']?.split('/')[0]}}
        is required</mat-error>
      <mat-error
        *ngIf="travelerSignupForm.get('alfursanID')?.hasError('pattern') && travelerSignupForm.get('alfursanID')?.touched">{{
        onBoardContent?.['b2b.managetraveler.efalfursanid']?.split('/')[0] }} 10 digit allowed only.</mat-error>

    </mat-form-field>
  </div>



  <div class="f-row m-top-40">
    <mat-checkbox class="checkbox-wrapper" (change)="onTermOfUseCheckboxChange($event)"
      formControlName="acceptTerms">{{onBoardContent?.['b2b.managetraveler.efaccepttermscheckbox'].replace('Terms of Use.','')}}
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
        of Use</a>.
    </mat-checkbox>
  </div>

  <div class="f-row m-top-8x">
    <mat-checkbox class="checkbox-wrapper" (change)="onPrivacyCheckboxChange($event)"
      formControlName="agreeConcent">{{onBoardContent?.['b2b.managetraveler.efprivacypolicycheckbox'].replace('Terms of Use and Privacy Policy.','')}}
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.saudia.com/en-SA/information/terms-and-conditions/terms-of-use?sc_lang=en&sc_country=SA">Terms
        of Use</a> and
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.saudia.com/en-IN/information/terms-and-conditions/privacy-policy">Privacy Policy</a>.
    </mat-checkbox>
  </div>
  <div class="f-row m-top-8x">
    <mat-checkbox class="checkbox-wrapper" formControlName="acceptPrivacy" (change)="onOfferCheckboxChange($event)">
      <div [innerHTML]="onBoardContent?.['b2b.managetraveler.efreceiveoffercheckbox']"></div>
    </mat-checkbox>
  </div>

  <div class="f-row justify-end m-top-8x btn-group">

    <button mat-button class="button--secondary-small" type="button" (click)="onCancel()">
      {{onBoardContent?.['b2b.managetraveler.cancel']}}
    </button>

    <button class="button--primary-small" mat-button (click)="onSubmit()"
      [class.disabled]="travelerSignupForm.invalid ||commonObj.isSubmitting">
      {{onBoardContent?.['b2b.managetraveler.save']}}

      <ng-container *ngIf="commonObj.isSubmitting">
        <mat-spinner class="button"></mat-spinner>
      </ng-container>

    </button>
  </div>
</form>